import types from './actionTypes'

function selectPage(name, page) {
  return {
    name,
    page,
    type: types.SELECT_PAGE
  }
}

function initializePagination(name, page = 0) {
  return {
    name,
    page,
    type: types.INITIALIZE_PAGINATION
  }
}

export {
  selectPage,
  initializePagination
}

export default {
  selectPage,
  initializePagination
}
